"use client";
import { useEffect, useState } from "react"
import { useLanguage } from "@/app/utils/LanguageContext";
import Footer from "@/app/ui/footer";
import { useParams, usePathname } from 'next/navigation';
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";

import { getTNCTrainersEntries, getBusinessDate } from "@/app/utils/request/requestList";
import { getFOStageResult, getAssetPrefix, getCurrentTimeFormatted, adobeData, getSearchParams, PoolState, updateMetaTag, MeetingState, RaceState, mapRaceClassList} from "@/app/utils/Common";
import Remarks from "@/app/ui/Common/remarks";
import "./index.scss";
import NoInformation from "@/app/ui/Common/NoInformation";
import dayjs from 'dayjs';
import _ from 'lodash';
import TrainersEntries from "@/app/ui/TrainersEntries";
import { pageSet } from "@/app/utils/pageSet";
const specilColumestyle= {
    backgroundColor: "#005297",
    color: "#fff",
    fontWeight: "bold",
}

const TNCEntries = (props:any) => {
    const { state: lang } = useLanguage();
    const [stage, setStage ] = useState(0);
    const { racedate } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));

    const [hasData, setHasData ] = useState(1);
    const [bizdate, setbizdate] = useState("");
    const [data, setData ] = useState({} as any);
    const [meetings, setMeetings ] = useState({} as any);
    const [meetingsList, setmeetingsList ] = useState([]);
    
    const [raceMeetings, setraceMeetings ] = useState([]);
    const [foPools, setfoPools ] = useState({} as any);
    const [tableTrainerList, settableTrainerList ] = useState([]);
    
    const [loading, setloading ] = useState(true);
    const [nextRacingDate, setnextRacingDate ] = useState("");
    const { t, langCode } = lang;
    const [currentRaceNo, setcurrentRaceNo ] = useState(0); 
    const assetPrefix = getAssetPrefix();
    const [curData, setcurData] = useState("");
    const [raceClassList, setraceClassList] = useState([] as any);
    useEffect(() => {
      updateMetaTag(langCode, pageSet.tncentries);
      adobeData(langCode, "pageview", {
        pageId: "racing/local",
      });

      // getBusinessDate().then((res: any) => {
      //   const resbizdate: string = res?.timeOffset?.ts?.substring(0, res?.timeOffset?.ts?.indexOf('+'));
  
      //   const regex = /^\d{4}\/\d{2}\/\d{2}$/;
      //   console.log(resbizdate, "resbizdate------------")
      //   if (regex.test(racedate) && dayjs(racedate).isBefore(resbizdate)) {
      //     console.log(resbizdate, "resbizdate isBefore------------")
      //     setHasData(2);
      //     setloading(false);
      //   } else {
      //     setbizdate(resbizdate);
      //   }
      // })
     
    }, [])

    useEffect(() => {
      // if (!bizdate) return

      getTNCTrainersEntries(null)
      .then((res: any) => {
        if(!res)
        {
          setHasData(2);
          setloading(false);
          return;
        } 
        console.log("getTrainersEntries", res)
        const resmeeting = res?.commonMeetings?.filter((x: any) => MeetingState("DECLARED").includes(x.status)) || [];
        if (!resmeeting || resmeeting?.length == 0) {
          if (!racedate) setHasData(3);
          else setHasData(2)

          setStage(2);
          setloading(false)
          return;
        }
        const commonMeetings = _.orderBy(resmeeting, ["date"])
        let curMtg = null as any;
        if (racedate && regex.test(racedate)) {
          setcurData(racedate)
          curMtg = commonMeetings?.find((x: any) => x?.date == racedate.replaceAll("/", "-"))
          if (!curMtg) {
            setHasData(2);
            setStage(2);
            setloading(false)
            return;
          }
        } else {
          curMtg = commonMeetings?.[0];
          setcurData(curMtg?.date.replaceAll("-", "/"))
        }
        const _tempraceClassList = mapRaceClassList(curMtg);
        setraceClassList(_tempraceClassList);
        getFOStageResult(curMtg?.date || null, "TNC").then((resStage:any) => {
          setStage(resStage);
          console.log("resStage-----", resStage)
          setloading(false);
            const currentNo = _.orderBy(curMtg?.races, ["no"])?.findLast((x: any) => RaceState("CLOSED").includes(x.status))?.no || 0;
            setcurrentRaceNo(currentNo);
    
            setMeetings(curMtg);
            const resmeetingRace = curMtg?.races || [];
            const tempfoPools = curMtg?.foPools?.reduce((latest:any, current:any) => {
              return new Date(current.lastUpdateTime) > new Date(latest.lastUpdateTime) ? current : latest;
          }, curMtg?.foPools?.[0]);
            const respmPools = curMtg?.pmPools || [];
            setmeetingsList(resmeeting);
            setraceMeetings(resmeetingRace);
            setfoPools(tempfoPools);
  
            const format_Date = 'DD/MM/YYYY';
            const tempDate = dayjs(curMtg?.date).format(format_Date);
            setnextRacingDate(tempDate);
            const poolRefund = PoolState("REFUND").includes(tempfoPools?.status);
  
            const otherSelNo = tempfoPools?.otherSelNo;
            const notIncludesStatus = ["Standby","Scratched"];
            console.log('【----tempfoPools?.selections】', tempfoPools?.selections)

            const trainerList = tempfoPools?.selections?.map((item:any) => {
              const trainerCode = item?.code;
              let trainerHorseList = [] as any;
              resmeetingRace?.forEach((ele:any) => {
                ele?.runners?.forEach((ele2:any) => {
                  let HName = "";
                  const xRes = tempfoPools?.resultSheet?.find((i:any) => i?.selStr == item?.number)?.result?.find((i:any) => i?.refId == trainerCode)?.raIncidents?.find((i:any) => i?.horseId == ele2?.horse?.id);

                  const ScratchedInd = xRes?.raIncidentType == "3";
                  if (!notIncludesStatus.includes(ele2?.status)) {
                    HName = langCode == "en-us" ? ele2?.horse?.name_en: ele2?.horse?.name_ch;
                    if (ele2?.trainer?.code == trainerCode) {
                      const targetWinOdds = respmPools?.find((i:any) => i?.leg?.number == ele?.no)?.oddsNodes?.find((ii:any) => parseInt(ii?.combString) == ele2?.no)?.oddsValue || "";
    
                      trainerHorseList.push({
                        HorseName: HName,
                        RaceNo: ele?.no,
                        HorseCode: ele2?.horse?.code,
                        HorseID: ele2?.horse?.id,
                        WinOdds: poolRefund ? 0 : parseFloat(targetWinOdds || ''),
                        trainerPreference: ele2?.trainerPreference > 1 ? ele2?.trainerPreference : "",
    
                        Points: (resStage < 5 || poolRefund || !xRes || "2" == xRes?.raIncidentType) ? 0 : xRes?.points || 0,
                        trumpCard: ele2?.trumpCard ? <>+{ ele2?.trainerPreference > 1? <>&nbsp;</>: ""}</>: "",
                        ScratchedInd,
                      })
                    }
                  }
                });
              });
              return {
                trainerCode,
                trainerName: langCode == "en-us" ? item?.name_en: item?.name_ch,
                trainerName_en: item?.name_en,
                SelNo: item?.number,
                Points: item?.points < 0 ? '---' : item?.points,
                Points_sort: item?.points,
                TrainerOdds: item?.currentOddsValue,
                trainerHorseList,
                others: item?.code == "OTHER"? true :false,
              }
            })
            
            if (tempfoPools?.otherResultSheet?.length) {
              const otherHorseList = tempfoPools?.otherResultSheet?.[0]?.otherResult?.map((ors:any) => {
                const trainerCode = ors?.refId;
                
                let tarTrainer = null;
                let trainerHorseList = [] as any;
                resmeetingRace?.forEach((ele:any) => {
                  ele?.runners?.forEach((ele2:any) => {
                    if (ele2?.trainer?.code == trainerCode) {
                      tarTrainer = ele2?.trainer;
                    }
                    let HName = "";
                    const xRes = ors?.raIncidents?.find((i:any) => i?.horseId == ele2?.horse?.id);
                    const ScratchedInd = xRes?.raIncidentType == "3";
                    if (!notIncludesStatus.includes(ele2?.status)) {
                      HName = langCode == "en-us" ? ele2?.horse?.name_en: ele2?.horse?.name_ch;
                      if (ele2?.trainer?.code == trainerCode) {
                        const targetWinOdds = respmPools?.find((i:any) => i?.leg?.number == ele?.no)?.oddsNodes?.find((ii:any) => parseInt(ii?.combString) == ele2?.no)?.oddsValue || "";
                        
                        trainerHorseList.push({
                          HorseName: HName,
                          RaceNo: ele?.no,
                          HorseCode: ele2?.horse?.code,
                          HorseID: ele2?.horse?.id,
                          WinOdds: poolRefund ? 0 : parseFloat(targetWinOdds || ""),
                          trainerPreference: ele2?.trainerPreference > 1 ? ele2?.trainerPreference : "",
                          Points: (resStage < 5 || poolRefund || !xRes || "2" == xRes?.raIncidentType) ? 0 : (xRes?.points ?? 0),
                          trumpCard: ele2?.trumpCard ? <>+{ ele2?.trainerPreference > 1? <>&nbsp;</>: ""}</>: "",
                          ScratchedInd
                        })
                      }
                    }
    
                  });
                }); 
                const curSelect = tarTrainer || tempfoPools?.otherSelections?.find((i:any) => i?.code == ors?.refId);
                const otherPoint = tempfoPools?.otherSelections?.find((i:any) => i?.code == ors?.refId)?.points ?? 0;
                return {
                  trainerCode: ors?.refId,
                  trainerName: langCode == "en-us" ? curSelect?.name_en || "": curSelect?.name_ch || "",
                  trainerName_en: curSelect?.name_en || "",
                  SelNo: otherSelNo,
                  Points: otherPoint < 0 ? '---' : otherPoint,
                  Points_sort:  otherPoint,
                  TrainerOdds: tempfoPools?.selections?.find((x: any) => x.combId == otherSelNo)?.currentOddsValue ?? 0,
                  trainerHorseList,
                  others: true
                }
              })
              otherHorseList?.forEach((iTem:any) => trainerList.push(iTem))
            }
            console.log('[trainerList22222]', JSON.parse(JSON.stringify(trainerList)));
            const normal = resStage > 4  ? trainerList?.sort((a:any, b:any) => {
              const aOddsCondition = Number(a.TrainerOdds ?? 0) < 1;
              const bOddsCondition = Number(b.TrainerOdds ?? 0) < 1;
              if (aOddsCondition !== bOddsCondition) {
                return (aOddsCondition ? 1 : 0) - (bOddsCondition ? 1 : 0);
              } 
  
              if (a.TrainerOdds !== b.TrainerOdds) {
                return a.TrainerOdds - b.TrainerOdds;
              }
  
              const aPoints = a.Points_sort;
              const bPoints = b.Points_sort;
              if (aPoints !== bPoints) {
                return bPoints - aPoints;
              }
              if (a.SelNo !== b.SelNo) return a.SelNo - b.SelNo
              
              return a?.trainerName_en.localeCompare(b?.trainerName_en, 'en', {sensitivity: "base"})
            })
            : trainerList?.sort((a:any, b:any) => {
              if (a.SelNo !== b.SelNo)  return a.SelNo - b.SelNo

              return a?.trainerName_en.localeCompare(b?.trainerName_en, 'en', {sensitivity: "base"})
            });

             console.log('[trainerList22222--111]', JSON.parse(JSON.stringify(normal)));
           
            const firstTrueIndex = normal?.findIndex((item:any) => item?.others);
            const firstTrueAndOtherIndex = normal?.findIndex((item:any) => item?.others && item?.trainerCode === "OTHER");
            const isFirefox = () => {
              return navigator.userAgent.indexOf('Firefox') !== -1 || typeof (window as any)?.InstallTrigger !== 'undefined';
            }
            if(firstTrueAndOtherIndex > firstTrueIndex && firstTrueIndex > -1 && firstTrueAndOtherIndex > -1) {
              let tempObj = JSON.parse(JSON.stringify(normal[firstTrueIndex]));
              normal[firstTrueIndex] = JSON.parse(JSON.stringify(normal[firstTrueAndOtherIndex]));
              normal[firstTrueAndOtherIndex] = tempObj;
              normal.sort((a:any, b:any) => {
                if (a.others == true && b.others == true &&
                  a?.trainerCode !== "OTHER" && b?.trainerCode !== "OTHER") {
                    const aPoints = a.Points_sort;
                    const bPoints = b.Points_sort;
                    if (aPoints !== bPoints) {
                      return bPoints - aPoints;
                    }

                    return a?.trainerName_en.localeCompare(b?.trainerName_en, 'en', {sensitivity: "base"})
                  }
                  return isFirefox() ? -1 : 1
              })
            }

            
           console.log('[normal_temp-----333333]', JSON.parse(JSON.stringify(normal)));
            normal.sort((a:any, b:any) => {
              const curIndx = normal?.findIndex((item:any) => item?.trainerCode === a.trainerCode);
              const bIndx = normal?.findIndex((item:any) => item?.trainerCode === b.trainerCode);
              // console.log('[000]', a.others, b.others, a.trainerCode, b.trainerCode)
              const compareSort = isFirefox() ? (b.others && !a.others) : (a.others && !b.others);
              const compareNum = isFirefox() ? 1 : -1;
              if (curIndx > firstTrueAndOtherIndex && bIndx > firstTrueAndOtherIndex && compareSort) {
                  // console.log('[111]', a.others, b.others, a.trainerCode, b.trainerCode)
                  return compareNum;
              }
              return 0
            })
            console.log('[normal_temp-----]', normal)
            settableTrainerList(normal);
        });
        // setHasData(1);
      })
      .catch((e: any) => {
        console.log(e);
        setloading(false)
      }).finally(() => {
          // setloading(false)
      });
     
    }, [])

  const renderRaceNoColumn = (No:any) => lang?.langCode == "en-us" ? `Race ${No}`: `第 ${No} 場`
  const renderStatus = (raceno:any) => {
    const abandonInd = raceClassList?.find((i:any) => i?.raceNo == raceno )?.AbandonInd;
    if (abandonInd > 1)  return t("Race_Abandoned").replace(" ", "<br/>")
    if (abandonInd > 0)  return t("Race_Voided").replace(" ", "<br/>")
    return ""
  }
  const renderTNCStatus = (stage: any) => {
      switch (stage) {
          case 4:
              
              return t("TNCTrainerStage4").replace("{0}", foPools?.instNo);
          case 5:
            if (currentRaceNo > 0) {
              return t("TNCTrainerStage5_0").replace("{0}", currentRaceNo.toString()).replace("{1}", foPools?.inplayUpTo);
            }
            return t("TNCTrainerStage5_1").replace("{1}", foPools?.inplayUpTo);
          case 6:
              return t("TNCTrainerStage6").replace("{0}", foPools?.instNo);
          default:
              return "";
      }
  }

  const handleBGColor = (raceNo: any) => {
    switch (meetings?.status) {
      case "ABANDON":
        return "tdBgGrer";
      // case "ABANDON_PARTIAL":
      //   return raceNo > meetings?.currentNumberOfRace ? 'tdBgYellow': "tdBgGrer";
      default:
        return raceNo > currentRaceNo ? 'tdBgYellow': "tdBgGrer";
    }
  }
  const AbandStatusNoShowOdd = (raceNo: any) => {
    // console.log('【-------------raceNo】', raceNo, currentRaceNo)
    switch (meetings?.status) {
      case "ABANDON":
        return false;
      // case "ABANDON_PARTIAL":
      //   return raceNo < meetings?.currentNumberOfRace ? true: false;
      default:
        return raceNo > currentRaceNo ? true :false;
    }
  }
  const imageSrc = `${assetPrefix}/images/title_TNC_trainerEntries_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`
  const directTitle = t("pagename_TrainerEntries")

  const rendersubItem = () => {
    return foPools?.instNo > 0 ? langCode == 'en-us' ? foPools?.oddsTypeDes?.english?.replace("{0}", foPools?.instNo) : foPools?.oddsTypeDes?.chinese?.replace("{0}", foPools?.instNo) : ""
  }
  const handleTitleDate = (date: string) => langCode == "en-us" ?
  `${new Date(date).getDate().toString().padStart(2, '0')} ${new Date(date).toLocaleString(langCode, { month: "short" })}`
  : `${new Date(date).toLocaleString(langCode, { month: "short" })}${new Date(date).getDate()}日 `;
  const regex = /^\d{4}\/\d{2}\/\d{2}$/;
  const handleRaceHeader = () => {
    return meetingsList?.map((item:any, idx:any) => {
        console.log('[------------item]', item)
        const curDate = handleTitleDate(item?.date);
        let btnClass = '';
        if (racedate && regex.test(racedate)) {
          if (racedate.replaceAll("/", "-") == item?.date){
            btnClass = "blueBtn1";
          }else {
            btnClass = "greyBtn";
          }
        } else {
          btnClass = idx == 0 ? "blueBtn1": "greyBtn"
        }
        return <a key={idx} className={btnClass} href={`/${langCode}/local/info/tnc-entries?racedate=${item?.date.replaceAll("-", "/")}`} onClick={(event) => {
          if(btnClass =="blueBtn1") event.preventDefault();
        }}> {curDate} - {t(item?.venueCode)}</a>
      })
  }

  if (loading || stage == 0) return null;
  return <>
  {
    hasData == 2 ? <>
    <div id='mainContainer'>
      <Header />
      <HeaderNav />
      <NoInformation type="noinfo" ssn_end={true} />
    </div>
    <Footer />
    </>:
      (hasData == 3 || (stage < 3 && meetingsList?.length == 0))? <>
      <div id='mainContainer'>
        <Header />
        <HeaderNav />
        <NoInformation type="inforeleasedshortly" ssn_end={true} />
      </div>
      <Footer />
      </> : (stage < 3) ? <TrainersEntries /> : <>
      <div id='mainContainer'>
        <Header />
        <HeaderNav />
        {
        Object.keys(meetings).length  ? <>
          <div className="commContent tncEntries f_fs13" id="trainerentries">
              <div style={{width: "920px"}}>
                  <div className="commTitlePic">
                      <img src={imageSrc} />
                  </div>
                  <div className="date_title f_tar">
                      {handleRaceHeader()}
                  </div>
              </div>

              <div id="TNC">
                  <div className="performance" id="TNC_info" style={{width: "920px"}}>
                      {
                        stage > 2 ?   <div className={`f_tar f_fs13 titleHoverColorPurple`}>
                            <u><a href={`/${langCode}/local/info/trainers-entries${curData? `?racedate=${curData}` : ""}`}>{directTitle}</a></u>
                        </div>: null
                      }
                      
                      <div className="f_fs13 f_clear">
                      <p className="f_fl" style={{marginRight:'50px'}}>{t("Race_Meeting")}: {nextRacingDate}</p>
                        <p className="f_fl" style={{marginRight:'100px'}}>{rendersubItem()}</p>
                        <p className="f_fl">
                            {
                              stage == 5 ? <img src={`${assetPrefix}/images/InPlay_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} style={{width: '98px', height: '20px', border: 0}} alt="" /> : null
                            }
                        </p>

                        <p className={`f_fr nav titleHoverColorPurple`}>{t("Last_Update_Time")} {getCurrentTimeFormatted()}<span>
                          <a onClick={()=> {window.location.href = window.location.href}} style={{cursor: "pointer"}}>[{t("Refresh")}]</a></span></p>
                      </div>
                      
                      <div className="data_title f_tar">
                          <span className="color_blue1 f_fs13" style={{ float: "right"}}>
                              {renderTNCStatus(stage)}
                          </span>
                      </div>
                      {
                        raceMeetings.length ?
                          <div className="margin_top10">
                            {
                              PoolState('REFUND').includes(foPools?.status) ? <div className="rowDiv5"><span className="color_red">{t("TNC_Refunded_Notes")?.replace("{0}", foPools?.instNo)}</span></div> : null
                            }
                            
                              <table id="trainersInfo" className="table_bd col_12 f_fs13" style={{width: "100%", lineHeight: langCode == "zh-hk" ? "150%" : "unset"}}>
                                  <thead>
                                      <tr className="bg_blue font_wb color_w">
                                        <td className="f_tac" rowSpan={2} style={{
                                          width: 60, 
                                          boxSizing:"unset",
                                          padding: "0 3px"}}>{t("TNC")}<br />{t("NO.")}</td>
                                        <td className="f_tac" rowSpan={2} style={{
                                          width: 80, 
                                          boxSizing:"unset",
                                          padding: "0 3px"}}>{t("trainer")}</td>
                                        {stage > 4 ? <td className="f_tac" rowSpan={2}
                                        style={{
                                          width: 80, 
                                          boxSizing:"unset",
                                          padding: "0 3px"}}
                                        >{t("TNC")}<br />{t("points")}<br />{t("score")}</td> : null}
                                        {stage > 3 ? <td className="f_tac" rowSpan={2}
                                        style={{
                                          width: 60,
                                          boxSizing:"unset",
                                           padding: "0 3px"}}
                                        >{t("TNC")}<br />{t("ODD")}</td> : null}
                                          {raceMeetings.map((race :any, indx: any)=> {
                                            if (foPools?.includeRaces?.includes(race?.no)) {
                                              return <td key={indx} className={`tdRace bg_blue ${race?.no > currentRaceNo ? '': "tdBgGrer"}`} style={{ width: "auto"}}
                                              >{renderRaceNoColumn(race?.no)}</td>
                                            }
                                            return null
                                          })
                                          }
                                      </tr>
                                      <tr className="tdBgYellow2 f_fs13 f_tac">             
                                          { raceMeetings?.map((race:any , indx:any)=> {
                                            if (foPools?.includeRaces?.includes(race?.no)) {

                                              let raceTrack = "";
                                              switch (race?.raceTrack?.code) {
                                                case "AWT":
                                                  raceTrack = lang?.langCode == "en-us" ? race?.raceTrack?.code : "全天候";
                                                  break;
                                                default:
                                                  raceTrack = lang?.langCode == "en-us" ? race.raceTrack.description_en: race.raceTrack.description_ch
                                                  break;
                                              }
                                              return <td key={indx} className={`R1 ${handleBGColor(race?.no)}`}>
                                              {race.claCode}<br />
                                              {race.distance}{t("Meter")}<br />
                                              {raceTrack}<br />
                                              <span dangerouslySetInnerHTML={{ __html: renderStatus(race?.no)}}/>
                                          </td>
                                            }
                                            return null
                                          })
                                          }
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {
                                        tableTrainerList?.map((trainer:any, indx:any)  => {
                                          const OthersLength = tableTrainerList?.filter((i:any) => i?.others).length;
                                          if (trainer?.trainerCode == "OTHER")  {
                                            return <tr className="tdBgWhite tdAlignC f_fs13" key={`trainer_${indx}`}>
                                            <td rowSpan={OthersLength} className="">{trainer?.SelNo}</td>
                                            <td>{t("trainerRanking_other")}</td>

                                            {
                                              stage > 4 ? <td className="">{trainer?.Points}</td> : null
                                            }
                                            {
                                              stage > 3 ? <td className=" color_red5" 
                                              >{trainer?.TrainerOdds}</td> : null
                                            }
                                            
                                            <td className="" colSpan={tableTrainerList.length} ></td>
                                          </tr>
                                          }
                                          if (trainer?.trainerCode != "OTHER" && trainer?.others)  { 
                                            return <tr key={`othertrainer_${indx}`}>
                                            <td  className=""><a href={`/${langCode}/local/information/trainerprofile?trainerid=${trainer?.trainerCode}`}>{trainer?.trainerName}</a></td>
                                            {
                                              stage > 4 ? <td className="">{trainer?.Points}</td>: null
                                            }
                                            {
                                              stage > 3 ?  <td className=""></td>: null
                                            }
                                          
                                            {
                                              foPools?.includeRaces?.map((no:any, indx2: any) => {
                                                return <td className="" key={indx2}>
                                                  {
                                                    trainer?.trainerHorseList.map((ot: any, idx: number) => {
                                                      if (ot?.RaceNo != no || ot.ScratchedInd) return null
                                                      const horseName = ot?.HorseName;
                                                      const winOdds = ot?.WinOdds;
                                                      return <div style={{border:0, paddingBottom: langCode == 'en-us' ? 5: "unset"}} key={idx}>
                                                              {AbandStatusNoShowOdd(ot?.RaceNo) && winOdds > 0 ? <><span className="color_red5">{winOdds}</span><br /></> : null}
                                                              <a href={`/${langCode}/local/information/horse?horseid=${ot.HorseID}`} style={{border:"0px"}}>{horseName}</a>
                                                              {
                                                                ot?.RaceNo <= currentRaceNo && ot?.Points > 0 ? <>
                                                                <br /><span className="color_red5">({ot?.Points})</span></> : null
                                                              }
                                                          </div>
                                                    })
                                                  }
                                                </td>
                                              })
                                            }
                                          </tr>
                                          }
                                          return (<tr key={indx}>
                                                <td className="" 
                                                >{parseInt(trainer?.SelNo)}</td>
                                                <td className="" 
                                                >
                                                  <a href={`/${langCode}/local/information/trainerprofile?trainerid=${trainer?.trainerCode}`}>{trainer?.trainerName}</a>
                                                </td>
                                                {
                                                  stage > 4 ? <td className="" 
                                                  >{trainer?.Points}</td> : null
                                                }
                                                {
                                                  stage > 3 ? <td className=" color_red5" 
                                                  >{trainer?.TrainerOdds}</td> : null
                                                }
                                                
                                                
                                              {
                                                foPools?.includeRaces?.map((no:any, indx2: any) => {
                                                  return  <td className="f_tac " key={indx2}>
                                                    {
                                                      trainer?.trainerHorseList?.map((i:any,idx:any) => {
                                                        if(i.RaceNo != no || i.ScratchedInd) return null;
                                                        const horseName = i?.HorseName;
                                                        const winOdds = i?.WinOdds;
                                                        return <div style={{border:0, paddingBottom: langCode == 'en-us' ? 5: "unset"}} key={idx}>
                                                                {AbandStatusNoShowOdd(i?.RaceNo) && winOdds > 0 ? <><span className="color_red5">{winOdds}</span><br /></> : null}
                                                                <a href={`/${langCode}/local/information/horse?horseid=${i.HorseID}`} style={{border:"0px"}}>{horseName}</a>
                                                                {
                                                                  i?.RaceNo <= currentRaceNo && i?.Points > 0 ? <>
                                                                  <br /><span className="color_red5">({i?.Points})</span></> : null
                                                                }
                                                            </div>
                                                      })
                                                    }
                                                </td>
                                                })
                                              }
                                        </tr>)
                                        })
                                      }
                                  </tbody>
                              </table>
                          </div>
                          :null
                      }
                  </div>
              </div>

              <Remarks path="TNCEntries" customClass="rowDiv15 fontStyle font12 lineH20"/>

            </div>
        </> : <NoInformation ssn_end={true} PageName={t("pagename_TrainerEntries")}DirectPageName={t("pagename_RaceCard")}/>
        }
      </div>
      <Footer />
      </>
  }
  </>
}

export default TNCEntries;